export { default as ComposerRenderSidebar } from './ComposerRenderSidebar';
